<template>
  <b-modal id="modal-consent" hide-footer centered no-close-on-esc no-close-on-backdrop hide-header-close>
    <template v-slot:modal-header="">
      <app-main-logo :link="false"/>
    </template>

    <h4>Remember - It is your choice!</h4>

    We use third-party services that collects necessary data like browser information, video tracking, ip,
    tracking, etc. for statistics purpose only to measure website traffic. Therefor we need your consent to
    continue to do that.<br><br>

    <ul>
      <li>
        By clicking <u>Full consent</u>, we will collect necessary data for statistics purpose only.

        <ul>
          <li>
            Wistia video (third-party)
          </li>
        </ul>
      </li>

      <li>
        By clicking <u>Necessary consent</u>, we will <strong>not</strong> collect any data, other then store a
        cookie with your consent answer.
        <ul>
          <li>
            Loyal Solutions consent answer
          </li>
        </ul>
      </li>
    </ul>

    <br><br>

    <div class="buttons-wrapper">
      <app-button-primary text="Full consent" v-on:click.native="consentFull"></app-button-primary>

      <app-button-secondary-black text="Necessary consent" v-on:click.native="consentNecessary"></app-button-secondary-black>
    </div>

    <template v-slot:modal-footer="">
      <br>
    </template>

  </b-modal>
</template>

<script>
  import AppButtonSecondaryBlack from '@/components/ui/buttons/AppButtonSecondaryBlack';
  import AppButtonPrimary from '@/components/ui/buttons/AppButtonPrimary';
  import AppMainLogo from '@/components/ui/logo/AppMainLogo';
  import ConsentConfig from '@/configs/consent-config';
  import WistiaVideo     from "@/models/wistia-video";

  // Plugins
  export default {
    name: "ModalConsent",

    components: {
      AppButtonSecondaryBlack, AppButtonPrimary, AppMainLogo,
    },

    data: function () {
      return {
        wistiaVideo: new WistiaVideo(),
      }
    },

    methods: {
      init() {
        let cookieVal = this.getCookie();

        // Wistia video init
        this.wistiaVideo.init();

        if (cookieVal === ConsentConfig.FULL_CONSENT) {
          this.consentFull();
        } else if (cookieVal === ConsentConfig.NECESSARY_CONSENT) {
          this.consentNecessary();
        } else {
          this.showModal();
        }
      },

      setCookie(consentType) {
        document.cookie = `${ConsentConfig.COOKIE_NAME}=${consentType};max-age=31622400;samesite=strict;secure`;
      },

      getCookie() {
        let cookie = document.cookie.split('; ').find(row => row.startsWith(ConsentConfig.COOKIE_NAME));

        if (cookie) {
          return cookie.split('=')[1];
        }

        return null;
      },

      consentFull() {
        let cookieVal = this.getCookie();

        if (cookieVal && cookieVal !== ConsentConfig.FULL_CONSENT) {
          this.kill();
        }

        this.setCookie(ConsentConfig.FULL_CONSENT);

        // Wistia
        this.wistiaVideo.startTracking();

        this.hideModal();
      },

      consentNecessary() {
        let cookieVal = this.getCookie();

        if (cookieVal && cookieVal !== ConsentConfig.NECESSARY_CONSENT) {
          this.kill();
        }

        this.setCookie(ConsentConfig.NECESSARY_CONSENT);

        this.hideModal();
      },

      kill() {
        // Wistia
        this.wistiaVideo.kill();

        location.reload();
      },

      showModal() {
        this.$bvModal.show('modal-consent');
      },

      hideModal() {
        this.$bvModal.hide('modal-consent');
      },
    },

    mounted() {
      this.$nextTick(function () {
        this.init();
      });
    },
  }
</script>

<style lang="scss" scoped>
  /deep/
  #modal-consent {
    border-radius: 0;
    min-height: 250px;
    padding: 0 !important;

    .buttons-wrapper {
      width: 100%;
      max-width: 300px;
      margin: auto;

      button {
        width: 100%;
        margin-bottom: 16px;
      }
    }

    table {
      font-size: 14px;
      margin-bottom: 0;
      table-layout: fixed;

      thead {
        display: none;
      }

      tbody tr td {
        padding: 2px;
        border: none;
      }

      tbody {
        border-bottom: 1px solid grey;
      }

      tbody tr {
        td {
          padding-top: 10px;

          &:first-child {
            width: 100px;
          }
        }

        &:last-child {
          td {
            padding-bottom: 10px;
          }
        }
      }
    }
  }
</style>
